export const ITEM_SEARCH_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'item',
};
